
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import DatetimeRange from 'vux/src/components/datetime-range/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

import {fetch,promptMessage } from '@/api/dataHandling';
import {preBodydefault} from '../../../static/js/preventWXUp';
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import wx from 'weixin-js-sdk';
import axios from 'axios';
import Vue from 'vue';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import $ from 'jquery';
import {timeCJ,setTimeHtml} from '../../../static/js/calendarPanle.js'
Vue.use(ConfirmPlugin);
export default {
data(){
return{
submitdisabled:false,
hospital:'武汉锦欣中西医结合妇产医院',
date:dateFormat(new Date(), 'YYYY-MM-DD'),
maxterm:'注射',
time:'',
hospitalOptions: [],
Projectid:'ff80808176d5197e0176da4c84c1000e',
orderSmallClassDm:'ff80808176d5197e0176da4fe4bd0011',
orderSmallClassName:'门诊注射'
}
},
components: {
Flexbox, FlexboxItem,Cell,dateFormat,XHeader,Group, PopupRadio,DatetimeRange, Datetime,XButton
},
methods:{
getlocations(hos){
var _this = this;
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)+'&openid='+this.$route.query.openid
).then(response => {
this.weixindata = response.data;
wx.config({
debug: false,
appId: _this.weixindata.appId,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
jsApiList: ['checkJsApi', 'openLocation', 'getLocation']
});
}).catch(function (error) {
promptMessage('获取appid失败: ' +error);

})
var _this = this;
wx.ready(function () {
wx.checkJsApi({
jsApiList: ['getLocation'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
success: function(res) {

}
});
/**wx.getLocation({
type:'wgs84',
fail:function (erorr) {

},
success:function(res){
var latitude = res.latitude; 
var longitude = res.longitude; 
function toRad(d) {  return d * Math.PI / 180; }
_this.hosArry = [];
for(let i =0;i<hos.length;i++){
hos[i]['location'] = hos[i]['location'].split(',');
hos[i]['distance'] = _this.getDisance(latitude,longitude, hos[i]['location'][0], hos[i]['location'][1]);
_this.hosArry.push(_this.getDisance(latitude,longitude, hos[i]['location'][0], hos[i]['location'][1]));
}
_this.hosArry.sort(function (a, b) {
return a-b;
});
for(let i =0;i<hos.length;i++){
if(_this.hosArry[0] ==hos[i].distance){
_this.hospital = hos[i]['areaId'];
this.hospital= _this.hospital;
_this.hospitalChoose();
}
}
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}
});*/


});
},
getDisance(lat1, lng1, lat2, lng2) {//lat为纬度, lng为经度, 一定不要弄错
var dis = 0;
var radLat1 = this.toRad(lat1);
var radLat2 = this.toRad(lat2);
var deltaLat = radLat1 - radLat2;
var deltaLng = this.toRad(lng1) - this.toRad(lng2);
var dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
return parseInt(dis * 6378137);
},
toRad(d) {
return d * Math.PI / 180;
},
getdateMthod(){
let _this = this;

return function() {
console.log(_this.Projectid,3333)
if(!_this.Projectid){
return function() {
return false;
};
}
_this.$store.commit('updateLoadingStatus', {isLoading: true});
fetch('get', urlConfig.reservationGeneralDatetimes + '?scheduleDate=' + _this.date + '&itemId=' + _this.Projectid).then(response => {
console.log(response, 222)
let timesArry = [];
for (let i = 0; i < response.length; i++) {
timesArry.push({key: response[i].id, value: response[i].shiftTime})
}
setTimeHtml(timesArry, 'time', _this);
_this.$store.commit('updateLoadingStatus', {isLoading: false});

}).catch(error => {

})
}
},
dateonChange(){
if(this.hospital !=""){
$('.mask-time, .time-area').show();
}else {
promptMessage('提示','请先选择院区！');
}
}, //日期选择
hospitalChoose(){
if(this.hospital=='82c6d395002e80810c77'){
this.Projectid="ff80808176d5197e0176da4fe4bd0011";
}else{
this.Projectid="0c1e2ca8af434bc185a5e0028bff102f";
}
this.time = "";
this.date = dateFormat(new Date(), 'YYYY-MM-DD');
this.getdateMthod()();
},  //获取项目
getData(){
fetch('get',urlConfig.getHospitalMsg).then(response => {
for(let i =0;i<response.length;i++){
this.hospitalOptions.push({key:response[i].areaId,value:response[i].areaName});
}


this.$store.commit('updateLoadingStatus',{isLoading:false});
this.getlocations(response);
}).catch(error => {

})
},
submint(){

if(this.hospital !='' && this.date !='' && this.time !=''){
this.submitdisabled = true;
let index = this.time.indexOf('(');
this.parmaData = new URLSearchParams();
this.parmaData.append('personInfoId',this.personInfoId);
this.parmaData.append('scheduleDate',this.date);
this.parmaData.append('shiftTime',this.time.substring(0,index));
this.parmaData.append('shiftTimeId',this.timeStepId);
this.parmaData.append('injectNum',0);
this.parmaData.append('orderLargeClassDm',this.Projectid);
this.parmaData.append('orderLargeClassName',this.maxterm);
this.parmaData.append('orderSmallClassDm',this.orderSmallClassDm);
this.parmaData.append('orderSmallClassName',this.orderSmallClassName);
this.parmaData.append('scheduleSource',"微信公众号预约");
let _this = this;
fetch('post',urlConfig.reservationGeneralSave,this.parmaData).then(response => {
promptMessage('提示','保存成功！',function () {
_this.$router.push({path:'/reservationIndex?openid='+_this.$route.query.openid,query:{tabindex:1,type:'zs',personInfoId:_this.personInfoId}});
});
}).catch(error => {
this.submitdisabled = false;
})
}else {
promptMessage('提示','还有选项未选择！');
}
}

},
mounted(){
let _this = this;
timeCJ('time','date',this,this.getdateMthod());
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.personInfoId = this.$route.query.personInfoId;
this.getData();
$('.mask-time').height($(window).height());
$('.btn-choose-time').click(function() {
_this.timeStepId = $('.time-table.choosed').attr('keyid')
if (_this.time =='') {
promptMessage('提示','请选择时间段')
}else{  //确认选择按钮
$('.mask-time,.time-area').css("display", "none");
}

});
}

}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/reservationInjection.vue